
export default function AboutHero() {
  return (
    <section className="relative pt-32 pb-20 px-6 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/64152ecee02215b7055765cdf1d03b67.jpg')`
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          About Us
        </h1>
        <p className="text-xl text-gray-200 font-light">
          Painters You Can Rely On
        </p>
      </div>
    </section>
  );
}
